import React, { useEffect, useRef, useState, useCallback } from "react";
import Menu from "./Menu/Menu";
import Field from "./Field/Field";
import { Button } from "./Button/Button";
import { observer } from "mobx-react-lite";
import { Question } from "./Question/Question";
import { Event } from "./Event/Event";
import { SubmitButton } from "./SubmitButton/SubmitButton";
import { PreviousPage } from "./PreviousPage/PreviousPage";
import { ForwardPage } from "./ForwardPage/ForwardPage";
import PaymentOptions from "./PaymentOptions/PaymentOptions";
import PaymentOptionsNew from "./PaymentOptionsNew/PaymentOptionsNew.js"; ///added new display
import { Discount } from "./Discount/Discount";
import { OrderSummary } from "./OrderSummary/OrderSummary";
import { GroupRegistration } from "./GroupRegistration/GroupRegistration";
import { FileUploader } from "./FileUploader/FileUploader";
import { ProfileImageUploader } from "./ProfileImageUploader/ProfileImageUploader";
import { Image } from "./Image/Image";
import { TextContent } from "./TextContent/TextContent";
import { IframeModule } from "./Iframe/Iframe";
import { ContentView } from "./ContentView/ContentView";
import { Paginator } from "./Paginator/Paginator";
import { Space } from "./Space/Space";
import { VideoModule } from "./Video/VideoModule";
import { EventGroup } from "./EventGroup/EventGroup";
import GoogleMaps from "./GoogleMaps/GoogleMaps";
import CalendarInvitation from "./CalendarInvitation/CalendarInvitation";
import QRCode from "./QRCode/QRCode";
import { runInAction } from "mobx";
import { createPortal } from "react-dom";
import { ImageGroup } from "./ImageGroup/ImageGroup";
import { Countdown } from "./Countdown/Countdown";
import { VoucherModule } from "./VoucherModule/VoucherModule";
import { ExhibitorInviteList } from "./ExhibitorInviteList/ExhibitorInviteList";
import Printer from "./Printer/Printer";
import ContentGroup from "./ContentGroup/ContentGroup";
import _ from "lodash";

export const cssIdGenerator = (contentLayoutModuleId) => {
  const alpha = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];
  let code = "";
  let id = contentLayoutModuleId.toString();
  for (let index = 0; index < id.length; index++) {
    code += alpha[id[index]]?.toUpperCase() || "";
  }
  return code;
};

const NON_AUTO_HEIGHT_MODULES = ["SPACE", "GOOGLE_MAPS", "CONTENT_VIEW", "IFRAME"];

export const ContentLayoutModule = observer((props) => {
  const [aspectRatio, setAspectRatio] = useState(null);
  const [renderSticky, setRenderSticky] = useState(false);
  const moduleRef = useRef();
  const checkHeightsRef = useRef();
  const { contentLayoutModuleId, type, settings, width, height, modulesRefs, contentModuleId, conditions, contentLayoutModule, hiddenElements, isSmartphone, posX, bodyWidth, activePersonNo } = props;
  const cssId = props.cssId || cssIdGenerator(contentLayoutModuleId);
  const settingsOverride = { ...settings };

  if (!modulesRefs) return null;
  if ((conditions[contentLayoutModuleId] && conditions[contentLayoutModuleId].hidden == true) || (isSmartphone && settingsOverride.hideOnMobile)) settingsOverride.hidden = true;
  useEffect(() => {
    props.checkConditions(contentLayoutModuleId);
  }, [activePersonNo]);

  useEffect(() => {
    if (settings?.aspectRatio && !aspectRatio) {
      setAspectRatio(settings.aspectRatio);
    } else if (!settings?.aspectRatio && aspectRatio) {
      setAspectRatio(null);
    }
  }, [settings?.aspectRatio]);

  if (renderSticky) {
    return createPortal(
      <div
        id={cssId}
        ref={moduleRef}
        className={`content-wrapper ${settings.prefixClassName} sticky`}
        style={{
          display: settingsOverride.hidden ? "none" : null,
          maxHeight: aspectRatio ? "unset" : NON_AUTO_HEIGHT_MODULES.includes(type) ? `calc(${height}px )` : undefined,
          aspectRatio: aspectRatio ? `${aspectRatio} / 1` : undefined,
        }}
      >
        <Module {...props} settings={settingsOverride} setAspectRatio={setAspectRatio} setRenderSticky={setRenderSticky} renderSticky={renderSticky} />
      </div>,
      document.getElementById("body")
    );
  }

  return (
    <div id={`${cssId}-grid-item`} className={"wrapper-grid-item content-wrapper"} style={{ width: "100%", display: "flex", height: "100%", justifyContent: "center", padding: 0, alignItems: "flex-start" }}>
      <div
        id={cssId}
        ref={moduleRef}
        className={`content-wrapper ${settings?.imitateField ? "cms-field" : settings.prefixClassName}`}
        style={{
          display: settingsOverride.hidden ? "none" : null,
          marginTop: hiddenElements ? hiddenElements * -1 + "px" : null,
          height: aspectRatio ? "unset" : NON_AUTO_HEIGHT_MODULES.includes(type) ? `calc(${height}px )` : undefined,
          // maxHeight: aspectRatio ? "unset" : NON_AUTO_HEIGHT_MODULES.includes(type) ? `calc(${height}px )` : undefined,
          aspectRatio: aspectRatio ? `${aspectRatio}` : undefined,
          width: "100%",
        }}
      >
        <Module {...props} settings={settingsOverride} setAspectRatio={setAspectRatio} setRenderSticky={setRenderSticky} renderSticky={renderSticky} checkHeights={() => null} />
      </div>
    </div>
  );
});

const Module = ({ type, ...rest }) => {
  switch (type) {
    case "FIELD":
      return <Field {...rest} />;
    case "IMAGE":
      return <Image {...rest} />;
    case "COUNTDOWN":
      return <Countdown {...rest} />;
    case "IMAGE_GROUP":
      return <ImageGroup {...rest} />;
    case "QUESTION":
      return <Question {...rest} />;
    case "SPACE":
      return <Space {...rest} />;
    case "IFRAME":
      return <IframeModule {...rest} />;
    case "GOOGLE_MAPS":
      return <GoogleMaps {...rest} />;
    case "CALENDAR_INVITATION":
      return <CalendarInvitation {...rest} />;
    case "QR_CODE":
      return <QRCode {...rest} />;
    case "EVENT":
      return <Event {...rest} />;
    case "EVENT_GROUP":
      return <EventGroup {...rest} />;
    case "MENU":
      return <Menu {...rest} />;
    case "SUBMIT_BUTTON":
      return <SubmitButton {...rest} />;
    case "FORWARD_PAGE":
      return <ForwardPage {...rest} />;
    case "PREVIOUS_PAGE":
      return <PreviousPage {...rest} />;
    case "BUTTON":
      return <Button {...rest} />;
    case "PAYMENT_OPTIONS":
      return <PaymentOptions {...rest} />;
    case "PRINTER": {
      return <Printer {...rest} />;
    }
    case "CONTENT_GROUP": {
      return <ContentGroup {...rest} />;
    }
    case "PAYMENT_OPTIONS_TWO":
      return <PaymentOptionsNew {...rest} />;
    case "DISCOUNT":
      return <Discount {...rest} />;
    case "ORDER_SUMMARY":
      return <OrderSummary {...rest} />;
    case "GROUP_REGISTRATION":
      return <GroupRegistration {...rest} />;
    case "PROFILEIMAGE_UPLOADER":
      return <ProfileImageUploader {...rest} />;
    case "FILE_UPLOADER":
      return <FileUploader {...rest} />;
    case "TEXT_CONTENT":
      return <TextContent {...rest} />;
    case "CONTENT_VIEW":
      return <ContentView {...rest} />;
    case "PAGINATOR":
      return <Paginator {...rest} />;
    case "VIDEO":
      return <VideoModule {...{ ...rest, type }} />;
    case "VOUCHER":
      return <VoucherModule {...rest} />;
    case "EXHIBITOR_INVITE_LIST":
      return <ExhibitorInviteList {...rest} />;
    case "LINK":
      return (
        <div className="jir-scroll" style={{ maxHeight: 200, overflow: "auto" }}>
          <a>Länk</a>
        </div>
      );
    // case "HOTEL_MODULE":
    //   return <Hotel {...rest} />;
    default:
      return <span>Module Type {type} not found.</span>;
  }
};
